import jsPDF from 'jspdf';
import { APP_CONFIG } from '../config/appConfig.js';
import { formatCurrency, formatNumber } from './calculations.js';

export const downloadCSV = (csvData, filename = 'generator-cost-calculation.csv') => {
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const generatePDF = (inputs, results) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  let yPosition = margin;

  // Title
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('Generator Cost Calculation Report', margin, yPosition);
  yPosition += 15;

  // Date
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(`Generated: ${new Date().toLocaleDateString('en-GB')}`, margin, yPosition);
  yPosition += 20;

  // Inputs section
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('Your Inputs:', margin, yPosition);
  yPosition += 10;

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  const inputLines = [
    `Monthly diesel used: ${formatNumber(inputs.litres)} litres`,
    `Diesel price per litre: ${formatCurrency(inputs.pricePerLitre)}`,
    `Generator hours per month: ${formatNumber(inputs.hours)} hours`,
    `Average load: ${formatNumber(inputs.avgLoad)} kW`
  ];

  inputLines.forEach(line => {
    doc.text(line, margin, yPosition);
    yPosition += 7;
  });

  yPosition += 10;

  // Results section
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('Calculated Results:', margin, yPosition);
  yPosition += 10;

  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  const resultLines = [
    `Monthly diesel spend: ${formatCurrency(results.monthlySpend)}`,
    `Estimated kWh generated: ${formatNumber(results.kWhGenerated)} kWh`,
    `Fuel-only cost per kWh: ${formatCurrency(results.fuelCostPerKwh, 3)}`,
    `All-in estimate range: ${formatCurrency(results.allInLow, 3)} - ${formatCurrency(results.allInHigh, 3)} per kWh`
  ];

  resultLines.forEach(line => {
    doc.text(line, margin, yPosition);
    yPosition += 7;
  });

  yPosition += 20;

  // Disclaimer
  doc.setFontSize(8);
  doc.setFont('helvetica', 'italic');
  const disclaimerText = 'Educational tool only. Not investment advice, and not an offer or solicitation. Results are estimates based on your inputs and may differ from real-world costs.';
  const splitText = doc.splitTextToSize(disclaimerText, pageWidth - 2 * margin);
  doc.text(splitText, margin, yPosition);

  return doc;
};

export const downloadPDF = (inputs, results, filename = 'generator-cost-report.pdf') => {
  const doc = generatePDF(inputs, results);
  doc.save(filename);
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return true;
    } catch (err) {
      document.body.removeChild(textArea);
      return false;
    }
  }
};